import { render, staticRenderFns } from "./ChannelPageHeaderCmp.vue?vue&type=template&id=826523f6&scoped=true&"
import script from "./ChannelPageHeaderCmp.vue?vue&type=script&lang=js&"
export * from "./ChannelPageHeaderCmp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelPageHeaderCmp.vue?vue&type=style&index=0&id=826523f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826523f6",
  null
  
)

export default component.exports